import { render } from "./SinchSms.vue?vue&type=template&id=b537563e"
import script from "./SinchSms.vue?vue&type=script&lang=js"
export * from "./SinchSms.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__